import { extractEnvelopeMessage } from '@core/http/api-response.envelope';

/**
 * What a create or edit of a policy actually did. policy-management answers
 * both with 200 and a "created" / "updated" message whether it applied the
 * change or only raised an approval request for it; only the body tells them
 * apart — `approvalRequestId` (with `stageNo`, `expiresAt`) when it was
 * queued (F-158).
 */
export type PolicySaveOutcome =
  | { kind: 'applied'; message: string | null }
  | { kind: 'queued'; approvalRequestId: string };

export function policySaveOutcome(response: unknown): PolicySaveOutcome {
  const data = (response as { data?: { approvalRequestId?: unknown } } | null)
    ?.data;
  const approvalRequestId = data?.approvalRequestId;
  if (typeof approvalRequestId === 'string' && approvalRequestId.length > 0) {
    return { kind: 'queued', approvalRequestId };
  }
  return { kind: 'applied', message: extractEnvelopeMessage(response) };
}

/** Where a queued change can be followed: the requester's own request page. */
export function approvalRequestRoute(approvalRequestId: string): string[] {
  return ['/dashboard/my-requests', approvalRequestId];
}
